// "Why this match" hint disabled — imports below are only used by the
// commented-out implementation inside the component (uncomment to restore).
// import { Sparkles } from 'lucide-react';
// import {
//   Tooltip,
//   TooltipContent,
//   TooltipProvider,
//   TooltipTrigger,
// } from '@/shared/components/ui/tooltip';

type NavigatorReasonHintProps = {
  reason: string;
  /** Accessible label + tooltip heading (from navigatorResultsCopy). */
  label?: string;
};

/**
 * Compact AI-reason affordance for alternate rows (feature 080 follow-up):
 * a sparkles icon that reveals the match rationale in a tooltip on
 * hover/focus, keeping the rows visually quiet.
 *
 * Render disabled: this affordance is hidden from the UI (see return null below).
 */
export const NavigatorReasonHint = (_props: NavigatorReasonHintProps) => {
  return null;

  /* Original implementation (uncomment to restore the "why this match" hint):
  const { reason, label = 'Why this match' } = _props;
  // Empty copy hides the affordance entirely — no orphaned icon.
  const text = reason.trim();
  if (!text) return null;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={label}
            className="inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full text-sage/70 transition-colors duration-150 ease-out hover:bg-sage-bg hover:text-sage focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-emphasis"
          >
            <Sparkles className="h-3.5 w-3.5" aria-hidden />
          </button>
        </TooltipTrigger>
        <TooltipContent
          side="top"
          align="end"
          // Warm sage panel — matches NavigatorReasonCallout, not the default
          // gray-900 tooltip chrome (feature 080 polish).
          className="max-w-xs rounded-xl border border-sage/20 bg-card-base px-3.5 py-2.5 text-text-primary shadow-[0_8px_24px_rgba(15,23,42,0.08)]"
        >
          <p className="mb-1 text-[9px] font-bold uppercase tracking-[0.12em] text-sage">
            {label}
          </p>
          <p className="text-xs leading-relaxed text-text-primary">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
  */
};
